import { ReactNode } from 'react';
import {
  BsInstagram,
  BsFacebook,
  BsTwitterX,
  BsLinkedin,
  BsWhatsapp,
  BsTelegram,
} from 'react-icons/bs';

export const availableSocials: { id: string; icon: ReactNode }[] = [
  {
    id: 'instagram',
    icon: <BsInstagram />,
  },
  {
    id: 'facebook',
    icon: <BsFacebook />,
  },
  {
    id: 'twitter',
    icon: <BsTwitterX />,
  },
  {
    id: 'linkedin',
    icon: <BsLinkedin />,
  },
];

export const availableMessengers: { id: string; icon: ReactNode }[] = [
  {
    id: 'whatsapp',
    icon: <BsWhatsapp />,
  },
  {
    id: 'telegram',
    icon: <BsTelegram />,
  },
];
